var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #e8ba3a;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke: #193c34;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.387096774193196,
    y: 5.129032258064399,
    width: 239.2258064516136,
    height: 199.7419354838712
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path651",
    className: "cls-3",
    d: "M228.522330718369631,152.88167742737096v8.376453219610994c0,1.936926238609885-1.570188957310165,3.507115195920051-3.507115195920051,3.507115195920051h-64.287180101349804c-1.936926238591695,0-3.507115195920051-1.570188957310165-3.507115195920051-3.507115195920051v-46.461827478049599c0-1.936926238609885,1.570188957328355-3.507115195920051,3.507115195920051-3.507115195920051h64.287180101349804c1.936926238609885,0,3.507115195920051,1.570188957310165,3.507115195920051,3.507115195920051v38.085374258438605Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path655",
    className: "cls-3",
    d: "M192.87162547178923,164.765245842902004v19.607887885618766"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path659",
    className: "cls-3",
    d: "M171.393821538595148,136.388045396104644v9.385954977225992"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "cls-3",
    d: "M203.745872536017487,139.447782577273756v6.326217796056881"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-3",
    d: "M182.177838537736534,129.597974874624924v16.176025498705712"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-3",
    d: "M192.961855536885196,135.2535965115203v10.520403861810337"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path675",
    className: "cls-3",
    d: "M214.529889535166149,133.575922085226921v12.198078288103716"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path707",
    className: "cls-3",
    d: "M157.220920225179725,152.88167742737096h71.301410493189906"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.15149874047893,
    y: 70.46080596858155,
    width: 36.2147834578991,
    height: 20.036867896789772,
    rx: 3.396584989688563,
    ry: 3.396584989688563
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.36628219837803,83.724972890891877h13.82440739878075c1.263260944169815,0,2.287336278179282,1.024075334009467,2.287336278179282,2.287336278190196v10.666928765200282c0,1.263260944169815-1.024075334009467,2.287336278170187-2.287336278179282,2.287336278170187H44.327091341698178c-1.26326094417891,0-2.287336278179282-1.024075334000372-2.287336278179282-2.287336278170187v-10.666928765200282c0-1.263260944180729,1.024075334000372-2.287336278190196,2.287336278179282-2.287336278190196h13.82440739878075"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.26171817560862,
    y: 87.47977524388261,
    width: 8.778036887910275,
    height: 7.816852167139587
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.850569427170356,83.724972890891877h9.125442940349295c.157685314757927,0,.28570578397008,.12802046921216,.28570578397008,.285705783970087v15.146203251020196c0,2.241187633986002-1.819560007448004,4.06074764143402-4.060747641434013,4.06074764143402h-1.575359241490908c-2.24118762505584,0-4.060747625253683-1.819560000197839-4.060747625253683-4.060747625253683v-15.146203267311392c0-.157685314696749,.128020469162486-.285705783859228,.285705783859228-.285705783859228Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.748960044998967,
    y1: 69.94133161570062,
    x2: 28.748960044998967,
    y2: 83.72497289089188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.396700328508814,
    y1: 75.84107605198187,
    x2: 38.246198275848656,
    y2: 75.84107605198187
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.47802587533806,
    y: 87.47977524388261,
    width: 8.77803688792119,
    height: 7.816852167139587,
    transform: "translate(229.734088638597314 182.776402654904814) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.316810420985334,83.724972890891991h1.575359215020242c2.241187668238993,0,4.060747703496077,1.819560035257084,4.060747703496077,4.060747703496077v15.146203187237134c0,.157685315707653-.128020469983227,.285705785690865-.28570578569088,.285705785690865h-9.125443039752483c-.157685315413232,0-.285705785157418-.128020469744186-.285705785157418-.285705785157418v-15.146203199182196c0-2.241187661940756,1.819560030143705-4.060747692084462,4.060747692084462-4.060747692084462Z",
    transform: "translate(248.208980205469118 186.942602276220839) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 123.76882089385981,
    y1: 69.94133161570062,
    x2: 123.76882089385981,
    y2: 83.72497289089188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.12108061035906,
    y1: 75.84107605198187,
    x2: 114.2715826630083,
    y2: 75.84107605198187
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.791510904888128,98.966574212452542h28.934759129071608v4.556496281698855c0,1.289385034879004-1.046817057211385,2.336202092090389-2.336202092090389,2.336202092090389h-24.262354944881736c-1.28938503488402,0-2.336202092099484-1.046817057215463-2.336202092099484-2.336202092099484v-4.556496281689761h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.795553991198176,105.85934992680086c-.536246808369469,3.681693448641454-3.706253279278826,6.509218118450008-7.536663521768787,6.509218118450008-3.830417262879564,0-7.000428333391028-2.827535034408356-7.53666647026148-6.509238361919415"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.48591277905416,
    y: 185.06541213429688,
    width: 209.11738689069443,
    height: 14.297798621259858,
    rx: 5.987483081220898,
    ry: 5.987483081220898
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.851452303368205,166.132552730901807c1.062369198480155-2.928470178219868,7.741713246190557-18.866136078759155,25.438573959339919-12.870307078879705,.243603337230525,.082534635799675,.384139941150352,.344140115539631,.31326241959141,.591386812078781-.852989683640772,2.975539731651224-6.576353460541213,19.776173138001468-25.458320188270591,12.899377082470892-.250964147129707-.091400926719871-.384600849949493-.369377709819673-.293516190660739-.620456815669968Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.794142407938125,166.132552730901807c-1.06236919848925-2.928470178219868-7.741713246188738-18.866136078759155-25.438573959339919-12.870307078879705-.243603337228706,.082534635799675-.384139941159447,.344140115539631-.313262419598686,.591386812078781,.852989683638953,2.975539731651224,6.576353460539394,19.776173138001468,25.458320188268772,12.899377082470892,.250964147151535-.091400926719871,.384600849951312-.369377709819673,.293516190669834-.620456815669968Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.794142407938125,
    y1: 166.1325527309018,
    x2: 55.794142407938125,
    y2: 185.06541212488082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.307906946198273,166.132552730901807c1.062369198480155-2.928470178219868,7.741713246179643-18.866136078759155,25.438573959330824-12.870307078879705,.243603337230525,.082534635799675,.384139941159447,.344140115539631,.313262419600505,.591386812078781-.852989683640772,2.975539731651224-6.576353460541213,19.776173138001468-25.458320188270591,12.899377082470892-.250964147129707-.091400926719871-.384600849949493-.369377709819673-.293516190660739-.620456815669968Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.250597050759097,166.132552730901807c-1.062369198480155-2.928470178219868-7.741713246179643-18.866136078759155-25.438573959330824-12.870307078879705-.243603337228706,.082534635799675-.384139941150352,.344140115539631-.313262419598686,.591386812078781,.852989683638953,2.975539731651224,6.576353460539394,19.776173138001468,25.458320188268772,12.899377082470892,.250964147129707-.091400926719871,.384600849949493-.369377709819673,.293516190660739-.620456815669968Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.2505970507591,
    y1: 166.1325527309018,
    x2: 114.2505970507591,
    y2: 185.06541212488082
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 203.74587253601703,
    cy: 130.2128116138556,
    r: 3.040784897665389
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 182.1778385377338,
    cy: 119.71820425249871,
    r: 3.040784897669482
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.39382153859515,
    y1: 130.2128116138556,
    x2: 179.1370536400609,
    y2: 121.50987552742845
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.78110665813256,
    y1: 121.28303354779564,
    x2: 200.70508763835096,
    y2: 129.2691197490658
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 215.30061348077834,
    y1: 125.49435228988659,
    x2: 206.7866574336822,
    y2: 130.2128116138556
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.294056728544092,124.03852043248844l2.534610828357472,.472000602927437c.305438671417505,.056879437051975,.510891919037022,.345534931493603,.464606233132145,.652757469151766l-.848729410603482,2.639086625831624"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.97558157804815,34.895079242691281c3.168506925139809-1.882781928328768,6.869105992900586-2.963957877200301,10.822227233860758-2.963957877200301,11.717169940540771,0,21.215812938500676,9.49864299795081,21.215812938500676,21.215812938491581,0,11.717169940549866-9.498642997959905,21.215812938509771-21.215812938500676,21.215812938509771-3.982588038919857,0-7.708875243519287-1.097354320319937-10.892993134439166-3.006194481589773"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.7978088119089,
    y1: 36.11088565399223,
    x2: 191.7978088119089,
    y2: 31.93112136549098
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 203.90450064577817,
    y1: 41.13712615943223,
    x2: 206.84697680581849,
    y2: 38.19464999940101
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 209.04628690996833,
    y1: 53.1503386884724,
    x2: 213.01362175040958,
    y2: 53.1503386884724
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 203.90450064577817,
    y1: 65.51728125482259,
    x2: 206.6634602209997,
    y2: 68.2762408300423
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.7978088119089,
    y1: 70.42797600152153,
    x2: 191.7978088119089,
    y2: 74.36274724249233
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 191.70713712704583,
    cy: 53.27671679879177,
    r: 3.242567215919053
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 187.26591138636832,
    y1: 57.74605159012208,
    x2: 189.45596894585833,
    y2: 55.55599403062115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193.91418391369916,
    y1: 50.90512956658131,
    x2: 201.2469481946191,
    y2: 43.794678610602205
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 155.6641463693595,
    y1: 53.1503386884724,
    x2: 180.89940224259954,
    y2: 53.1503386884724
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.11684780846917,
    y1: 46.07499665782234,
    x2: 181.95080648404837,
    y2: 46.07499665782234
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 169.93404757447934,
    y1: 39.0030590116512,
    x2: 183.79953862397815,
    y2: 39.0030590116512
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.11684780846917,
    y1: 60.21887195015188,
    x2: 181.95080648404837,
    y2: 60.21887195015188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 169.93404757447934,
    y1: 67.2908095963212,
    x2: 183.79953862397815,
    y2: 67.2908095963212
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.7978088119089,
    y1: 106.581617477681,
    x2: 191.7978088119089,
    y2: 74.41373025306166
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.130760600799476,65.648767058512021v-9.88143456518992c0-1.726844682019873,1.399884206568458-3.126728888581056,3.126728888588332-3.126728888581056h71.559281332551109"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.3f3edd9b3c73b21ad1d125dc6e3cfc25.svg";
export { ForwardRef as ReactComponent };